import { combineReducers } from "redux";
import auth from './auth';
import alert from './alert';
import users from './users';

import empresas from './empresas';

export default combineReducers({
  auth,
  alert,
  users,
  empresas
});